/**
 * 枚举数据存储 reducer
 */
import { 
  iReviewStatusEnum, 
  SET_REVIEW_STATUS_ENUM,
  iBatchTaskFuncTypeEnum,
  SET_BATCH_TASK_FUNC_TYPES,
  iBatchTaskStatusEnum,
  SET_BATCH_TASK_STATUSES
} from './type';

interface EnumStoreState {
  reviewStatusEnum: iReviewStatusEnum[];
  batchTaskFuncTypes: iBatchTaskFuncTypeEnum[] | null;
  batchTaskStatuses: iBatchTaskStatusEnum[] | null;
}

const initState: EnumStoreState = {
  reviewStatusEnum: [],
  batchTaskFuncTypes: null,
  batchTaskStatuses: null,
};

export const enumStore = (state = initState, action: any) => {
  switch (action.type) {
    case SET_REVIEW_STATUS_ENUM:
      return {
        ...state,
        reviewStatusEnum: action.payload,
      };
    case SET_BATCH_TASK_FUNC_TYPES:
      return {
        ...state,
        batchTaskFuncTypes: action.payload,
      };
    case SET_BATCH_TASK_STATUSES:
      return {
        ...state,
        batchTaskStatuses: action.payload,
      };
    default:
      return state;
  }
};
